export default function ContactDetails({ block }) {
  const hasVisit = block.visitName || block.visitAddress || block.mapLink;
  const hasCall = !!block.phoneLink;
  const hasConnect = block.connectLinks?.length > 0;

  if (!hasVisit && !hasCall && !hasConnect) return null;

  return (
    <div className="GravityForm-contactDetails">
      {block.contactHeading && (
        <p className="h5 GravityForm-contactHeading headingStrong">
          {block.contactHeading}
        </p>
      )}

      {hasVisit && (
        <div className="GravityForm-contactRow">
          <p className="h8 GravityForm-contactLabel headingStrong">Visit</p>
          <div className="GravityForm-contactValue">
            {/* {block.visitName && <p>{block.visitName}</p>} */}
            {block.mapLink && (
              <p dangerouslySetInnerHTML={{ __html: block.mapLink.title }} />
            )}
            {block.mapLink && (
              <a
                className="GravityForm-contactMapLink"
                href={block.mapLink.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                View map
              </a>
            )}
          </div>
        </div>
      )}

      {hasCall && (
        <div className="GravityForm-contactRow">
          <p className="h8 GravityForm-contactLabel headingStrong">Call</p>
          <div className="GravityForm-contactValue">
            <a href={block.phoneLink.url}>
              {block.phoneLink.title || block.phoneLink.url}
            </a>
          </div>
        </div>
      )}

      {hasConnect && (
        <div className="GravityForm-contactRow">
          <p className="h8 GravityForm-contactLabel headingStrong">Connect</p>
          <div className="GravityForm-contactValue">
            {block.connectLinks.map((item, index) => (
              <a
                key={index}
                href={item.url}
                target={item.target || undefined}
                rel={
                  item.target === '_blank' ? 'noopener noreferrer' : undefined
                }
              >
                {item.title || item.url}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
